import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Select } from 'foundations-components/transitional/components/Select';
import { useMemo } from 'react';
import { useSelectItemComponentShim } from '../hooks/useSelectItemComponentShim';
import { useUserAndTeamOptionIds } from '../hooks/useUserAndTeamOptionIds';
import { searchResults } from '../operators/searchResults';
import { selectUserTeamIds } from '../utils/selected-users-teams';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getGroupText = (header = {}, fallback) => {
  const group = {
    text: header.copy || fallback
  };
  if (header.tooltip) {
    group.dropdownText = /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "100",
      children: [group.text, /*#__PURE__*/_jsx(HelpIcon, {
        title: header.tooltip
      })]
    });
  }
  return group;
};
const getGroupedOptionsFromLists = (users, teams, {
  teams: teamsContext,
  users: usersContext
} = {}) => [Object.assign({}, getGroupText(teamsContext === null || teamsContext === void 0 ? void 0 : teamsContext.header, I18n.text('routing-ui.users-and-teams.groups.team')), {
  options: teams !== null && teams !== void 0 ? teams : []
}), Object.assign({}, getGroupText(usersContext === null || usersContext === void 0 ? void 0 : usersContext.header, I18n.text('routing-ui.users-and-teams.groups.user')), {
  options: users !== null && users !== void 0 ? users : []
})];
export const RoutableUsersAndTeamsSelect = ({
  'data-test-id': testId,
  disabled,
  error,
  footer,
  itemComponent,
  loading,
  onChange,
  menuRenderer,
  placeholder,
  overrides,
  selected,
  teams,
  users,
  valueComponent
}) => {
  const options = useMemo(() => getGroupedOptionsFromLists(users, teams, overrides), [overrides, teams, users]);
  const optionIds = useUserAndTeamOptionIds({
    teamOptions: teams,
    userOptions: users
  });
  const ItemComponent = useSelectItemComponentShim(itemComponent);
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  const handleChange = ({
    target
  }) => {
    const newIds = selectUserTeamIds(target.value, optionIds);
    onChange(newIds.users, newIds.teams);
  };
  return /*#__PURE__*/_jsx(FormControl, {
    error: !!error,
    validationMessage: error || null,
    children: /*#__PURE__*/_jsx(Select, {
      anchorType: "button",
      cache: false,
      "data-test-id": testId,
      disabled: disabled,
      dropdownFooter: footer,
      filterOptions: searchResults,
      isLoading: loading,
      itemComponent: ItemComponent,
      menuRenderer: menuRenderer,
      menuStyles: {
        maxBlockSize: '320px'
      },
      multi: true,
      onChange: handleChange,
      options: options,
      placeholder: placeholder || I18n.text('routing-ui.users-and-teams.select.placeholder'),
      value: selected,
      valueComponent: valueComponent
    })
  });
};
RoutableUsersAndTeamsSelect.displayName = 'RoutableUsersAndTeamsSelect';